"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DynamicBreadcrumbsProvider = require("./DynamicBreadcrumbsProvider");

var FinalBreadcrumb = function FinalBreadcrumb(_ref) {
  var Component = _ref.component,
      _ref$renderChildren = _ref.renderChildren,
      renderChildren = _ref$renderChildren === void 0 ? function (children) {
    return children;
  } : _ref$renderChildren,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["component", "renderChildren"]);

  var _useBreadcrumbsContex = (0, _DynamicBreadcrumbsProvider.useBreadcrumbsContext)(),
      breadcrumbs = _useBreadcrumbsContex.breadcrumbs;

  var _ref2 = breadcrumbs[breadcrumbs.length - 1] || {},
      _ref2$children = _ref2.children,
      children = _ref2$children === void 0 ? null : _ref2$children;

  return children && /*#__PURE__*/_react["default"].createElement(Component, props, renderChildren(children));
};

FinalBreadcrumb.propTypes = {
  component: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  renderChildren: _propTypes["default"].func
};
FinalBreadcrumb.defaultProps = {
  component: 'span',
  renderChildren: function renderChildren(children) {
    return children;
  }
};
var _default = FinalBreadcrumb;
exports["default"] = _default;